export default class LegislativeChoroplethStyleConfig {
    constructor(){
        this.config = {
            deviation: { //Must match column name!
                title: "<span class='text-h6'>Difference from Average</span><br />",
                titleplaintext: "Difference from Average",
                // description: "<strong>Congress:</strong> <em>based on projected # of seats</em>. <br /><strong>State Legislature:</strong> current population estimates.",
                // description: "<em>District population estimate compared<br />w/ state avg based on state's 2019 ACS pop. estimate<em>",
                description: "<em>District population compared<br />w/ state avg based on 2020 Census<em>",
                scale:[ 
                    //Brown to Purple CB ['#b35806','#e08214','#fdb863','#fee0b6','#f7f7f7','#d8daeb','#b2abd2','#8073ac','#542788'] 
                    //Orange to green CB combo ['#b35806','#e08214','#fdb863','#fee0b6','#f7f7f7', '#d9ef8b','#a6d96a','#66bd63','#1a9850']
                    {
                        color:"#b35806", //d73027
                        step:[-0.1, true] //need to expand
                    },
                    {
                        color:"#e08214", //f46d43
                        step:[-0.1,false,-.05,false]
                    },
                    {
                        color:"#fdb863", //fdae61
                        step:[-0.05,true,-.02,false]
                    },
                    {
                        color:"#fee0b6", //fee090
                        step:[-0.02,true,-.001,false]
                    },
                    {
                        color:"#ededed", //ebebeb gray
                        step:[-0.001,true,0.001,true]
                    },
                    {
                        color:"#d9ef8b", //e0f3f8
                        step:[0.001,false,0.02,false]
                    },
                    {
                        color:"#a6d96a", //abd9e9
                        step:[0.02,true,0.05,false]
                    },
                    {
                        color:"#66bd63", //74add1
                        step:[0.05,true,.1,false]
                    },
                    {
                        color:"#1a9850", //4575b4
                        step:[.1, true] //need to shrink 
                    }
                ],
                getLegendValues: function(scale){

                    return [
                        {
                            color: scale[0]['color'],
                            label: '10% or more below avg. population'
                        },
                        {
                            color: scale[1]['color'],
                            label: '5%-10% below avg. pop.'
                        },
                        {
                            color: scale[2]['color'],
                            label: '2%-5% below avg. pop.'
                        },
                        {
                            color: scale[3]['color'],
                            label: 'up to 2% below avg. pop.'
                        },
                        {
                            color: scale[4]['color'],
                            label: 'Average'
                        },
                        {
                            color: scale[5]['color'],
                            label: 'up to 2% above avg. pop.'
                        },
                        {
                            color: scale[6]['color'],
                            label: '2%-5% above avg. pop.'
                        },
                        {
                            color: scale[7]['color'],
                            label: '5%-10% above avg. pop.'
                        },
                        {
                            color: scale[8]['color'],
                            label: '10% or more above avg. pop.'
                        }
                    ]
                }
            }            

                                //Brown to blue-gold CB ['#543005','#8c510a','#bf812d','#dfc27d','#f6e8c3','#c7eae5','#80cdc1','#35978f','#01665e','#003c30'] - VB preference
                                
                    //Orange to purple ColorBrewer ['#b35806','#e08214','#fdb863','#fee0b6','#f7f7f7','#d8daeb','#b2abd2','#8073ac','#542788'] 

                    //RedOrange to Green CB ['#d73027','#f46d43','#fdae61','#fee08b','#ffffbf','#d9ef8b','#a6d96a','#66bd63','#1a9850']

                    //['#d53e4f','#f46d43','#fdae61','#fee08b','#ffffbf','#e6f598','#abdda4','#66c2a5','#3288bd']
            ,
            popchgpct1020: {
                // title: "<span class='text-h6'>Estimated Population<br />Change 2010-2019</span><br />",
                // titleplaintext: "Estimated Population Change 2010-2019",
                title: "<span class='text-h6'>Population Change<br />2010-2020</span><br />",
                titleplaintext: "Population Change 2010-2020",
                description: null,
                //popThreshold: .05,
                //thresholdColumn: 'pop2019',
                scale:[ //Orange to Purple CB ['#b35806','#e08214','#fdb863','#fee0b6','#f7f7f7','#d8daeb','#b2abd2','#8073ac','#542788']
                //Orange to green CB combo ['#b35806','#e08214','#fdb863','#fee0b6','#f7f7f7', '#d9ef8b','#a6d96a','#66bd63','#1a9850']
                {
                    color:"#b35806",
                    step:[-0.1,true] //pop decrease
                },{
                        color:"#e08214",
                        step:[-0.1,false,-.05,false]
                    },
                    {
                        color:"#fdb863",
                        step:[-0.05,true,-0.001,false]
                    },
                    {
                        color:"#ededed", //ebebeb gray
                        step:[-0.001,true,0.001,true]
                    },
                    {
                        color:"#d8daeb",
                        step:[0.001,false,0.05,false]
                    },
                    {
                        color:"#b2abd2",
                        step:[0.05,true,0.1,false]
                    },
                    {
                        color:"#8073ac",
                        step:[0.1,true,.2,false]
                    },
                    {
                        color:"#542788",
                        step:[.2, true] 
                        
                    }
                    // ,
                    // {
                    //     color:"#b2abd2",
                    //     step:[0,false,0.05,false]
                    // },
                    // {
                    //     color:"#8073ac",
                    //     step:[0.05,true,.1,false]
                    // },
                    // {
                    //     color:"#542788",
                    //     step:[.1, true] 
                        
                    // }
                    //pop increase 
                ],
                getLegendValues: function(scale){
                    return [
                        {
                            color: scale[0]['color'],
                            label: 'Population fell 10% or more'
                        },{
                            color: scale[1]['color'],
                            label: 'Decreased up to 10%'
                        },
                        {
                            color: scale[2]['color'],
                            label: 'Decreased up to 5%'
                        },
                        {
                            color: scale[3]['color'],
                            label: 'No change (+/- 0.1%)'
                        },
                        {
                            color: scale[4]['color'],
                            label: 'Increased up to 5%'
                        },
                        {
                            color: scale[5]['color'],
                            label: 'Increased 5% to 10%'
                        },
                        {
                            color: scale[6]['color'],
                            label: 'Increased 10% to 20%'
                        },
                        {
                            color: scale[7]['color'],
                            label: 'Population grew by 20% or more'
                        },
                    ]
                },
            }
        }
    }
}